import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Toaster } from "@/components/ui/sonner";
import Index from './pages/Index';
import Servizi from './pages/Servizi';
import ChiSiamo from './pages/ChiSiamo';
import Contatti from './pages/Contatti';
import Prenotazioni from './pages/Prenotazioni';
import Articoli from './pages/Articoli';
import ArticoloDettaglio from './pages/ArticoloDettaglio';
import ConsensoInformatoPage from './pages/ConsensoInformatoPage';
import Tariffe from './pages/Tariffe';
import NotFound from './pages/NotFound';
import './App.css';

function App() {
  return (
    <Router>
      <div className="min-h-screen bg-background">
        <Routes>
          <Route path="/" element={<Index />} />
          <Route path="/servizi" element={<Servizi />} />
          <Route path="/chi-siamo" element={<ChiSiamo />} />
          <Route path="/contatti" element={<Contatti />} />
          <Route path="/prenotazioni" element={<Prenotazioni />} />
          <Route path="/articoli" element={<Articoli />} />
          <Route path="/articoli/:slug" element={<ArticoloDettaglio />} />
          <Route path="/consenso-informato" element={<ConsensoInformatoPage />} />
          <Route path="/tariffe" element={<Tariffe />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
        <Toaster />
      </div>
    </Router>
  );
}

export default App;